import {shallowEqual, useSelector} from 'react-redux'
import {Navigate, Outlet} from 'react-router-dom'
import {UserModel} from '../../modules/auth/models/UserModel'
import {RootState} from '../../../setup'
import {useCustomeStore} from '../../../stores/CustomeStore'
import useAnalyticGuard from '../../../functions/Guard/analyticGuard'

const AnalyticsTemplateWrapper: React.FC = () => {
  const user: UserModel = useSelector<RootState>(({auth}) => auth.user, shallowEqual) as UserModel
  const {hasAccess:hasAccessAnalytic} = useAnalyticGuard(user)
  if (
    !(hasAccessAnalytic)
  ) {
    return <Navigate to='/error/404' replace />
  }
  return <Outlet />
}

export {AnalyticsTemplateWrapper}
